module.exports = __webpack_public_path__ + "img/lovely.4be66218.svg";